import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation } from 'types'

const StyledEyeClosedIcon = styled(EyeNoneIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

const StyledEyeOpenIcon = styled(EyeOpenIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ToggleAnnotationVisibilityButton: FC<{
  annotation: KVAnnotation
}> = ({ annotation }) => {
  const { updateAnnotation } = useKestrel()

  const toggleAnnotationVisibility = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isVisible = annotation.visible
    if (updateAnnotation)
      updateAnnotation(
        annotation,
        'annotationVisible',
        (a: KVAnnotation) => {
          a.visible = !isVisible
          return a
        },
        !isVisible
      )
  }

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={(e) => toggleAnnotationVisibility(e)}>
      {annotation.visible ? (
        <StyledEyeOpenIcon width={22} height={22} />
      ) : (
        <StyledEyeClosedIcon width={22} height={22} />
      )}
    </div>
  )
}
